/**
 * @module responseRate ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { uiActions } from '~/behaviors/actions/ui.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { convert } from '~/tools/convert';

const defaultState = {
  requestHierarchyAttribute: false,
};

const reset = () => defaultState;

const changeUI = (state, action) => {
  const updates = action?.payload || {};
  // @ts-expect-error TS(2345): Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
  const sanitizedAttrs = convert.pick(updates, Object.keys(defaultState));

  return {
    ...state,
    ...sanitizedAttrs,
  };
};

const responseRateUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(uiActions.changeResponseRateUI, changeUI);
});

export default responseRateUI;
